<template>
  <div class="page wallet">
    <div class="title">
      <mu-appbar class="center">
        <mu-icon value="keyboard_arrow_left" color="white" slot="left" v-on:click="goback" />
        <span class="topT left">信用卡支付</span>
      </mu-appbar>
    </div>
    <div class="form" id='payMsg'>

      <div style="width:100% ; text-align:left ;  margin:0.2rem 0 0rem 0">
        <label class="title" style=" width:1.3rem ">卡号</label>
        <!--<span style=" color:#666666 ;font-size:0.3rem ; ">卡号</span>-->
        <span style="margin-left: 0rem ;  font-weight:bold ;color:#333333 ;font-size:0.3rem ; ">
          {{ g_PayOrder.CardReplace }}( {{ PageBankName }}{{ g_PayOrder.CardType }} )
        </span>
      </div>

      <!--<div style="width:92% ; text-align:left ;  margin:0.2rem 0 0.2rem 0">
              <span style=" color:#666666 ;font-size:0.3rem ; ">卡号</span>
              <span style="margin-left:0.6rem ;  font-weight:bold ;color:#333333 ;font-size:0.3rem ; " >
              {{this.g_PayOrder.CardReplace  }}( {{ this.g_PayOrder.BankName }}{{ this.g_PayOrder.CardType }} )
            </span>
          </div>
    
          <div style="width:99% ; text-align:left ;  margin:0.2rem 0 0.2rem 0">
            <span style=" color:#666666 ;font-size:0.3rem ; ">CVN2</span>
              <input v-model="cvn2"   style="  margin-left:0.4rem  ;  border:0 ; outline:0 ;    font-size:0.3rem ; width: 3rem" placeholder="卡背面三位" />
              <mu-icon @click="open(1)"  style=" float:right "  value="help_outline" color='#27ba69' />
          </div>-->

      <div>
        <label class="title" style=" width:1.3rem ">CVN2</label>
        <input v-model="CVN2" type="text" placeholder="卡背面三位" />
        <mu-icon @click="open(1)" class="tip" value="help_outline" color='#27ba69' />
      </div>
      <div>
        <label class="title" style=" width:1.3rem ">有效期</label>
        <input class="date" v-model="month" type="text" placeholder="月份" />
        <span class='amount'>月</span>&nbsp;&nbsp;
        <input class="date" v-model="year" type="text" placeholder="年份" />
        <span class='amount'>&nbsp;&nbsp;年</span>
        <mu-icon @click="open(0)" class="tip" value="help_outline" color='#27ba69' />
      </div>
      <div>
        <label class="title" style=" width:1.3rem ">手机号</label>
        <input v-model="Phone" type="text" placeholder="请输入手机号" />
      </div>

      <!--<div>
          <label class="title relative" style=" width:1.3rem ">附加码</label>
          <input v-model="FJM" type="text" placeholder="请输入附加码" style="width:3rem" />
          <img v-bind:src="TPFJM" style="width:24% ;  ; margin-bottom:-2%" v-on:click="this.getValidateCode" align="right" />
        </div>-->

      <div>
        <label class="title relative" style=" width:1.3rem ">验证码</label>
        <input v-model="YZM" type="text" placeholder="请输入验证码" />
        <div id='get' >
          <span v-show="haveYZM == false">
            <input type="button" value="获取" v-on:click="GetValidateCodeForCreditPay()"  style="font-size:0.28rem "   />
          </span>
          <span v-show="haveYZM == true">
            <input type="button" v-model="WaitTime" style="   background-color:#eeeeee ;   font-size:0.28rem  ;   color:#999 ;"  />
          </span>
        </div>

      </div>
    </div>
    <mu-raised-button label="立即支付" primary v-bind:style="{ width:'96%',height:'50px',margin:'2%'}" v-on:click="PayByUnionPayCreditCardFirst()" />
    <div>
      <mu-dialog :open="dialog" @close="close">
        <div style="margin:-27px;">
          <img v-bind:src="url" style="height:100%;width:100%" />
        </div>
      </mu-dialog>
    </div>

    <mu-toast id="alertline" v-if="toast" v-bind:message="TellUser" @close="hideToast" />
  </div>
</template>



<script>


import { mapMutations, mapGetters } from 'vuex'
import api from '../../../api'



export default {
  computed: {
    ...mapGetters([
      'g_UserInfo', 'g_PayOrder',
    ])
  },
  data() {
    return {

      haveYZM: false,
      WaitTime: '',
      CloseTime: 29,


      toast: false,
      dialog: false,
      url: '',

      CVN2: '',
      month: '',
      year: '',
      Phone: '',
      YZM: '',
      FJM: '',

      TPFJM: '',

      PageBankName:'',
    }
  },

  activated() {

    this.Ispay = false;

    this.init();
  },
  methods: {
    ...mapMutations([
      'setG_PayOrder',
    ]),

    init() {
      this.CVN2 = '';
      this.month = '';
      this.year = '';
      this.Phone = '';
      this.YZM = '';
      this.FJM = '';

      this.getValidateCode();

      this.GetCreditBankName();

    },

    GetCreditBankName() {
      var params = new this.URLSearchParam();
      params.append('parentNo', this.g_PayOrder.OrderId);
      params.append('bankCard', this.g_PayOrder.CardNo);
      params.append('payMoney', this.g_PayOrder.Money);
      params.append('orderType', this.g_PayOrder.TypeId)
      this.$http.post(api.GetCreditBankName(this.g_PayOrder.PayFor), params.toParam()).then((res) => {
        console.log(res)

        if (res.Result) {
          // var Order = this.g_PayOrder;
          // this.setG_PayOrder(Order);
          
          this.PageBankName = res.Data.BankName.split('银行')[0] + '银行';

        }
        else {
          this.TellUser = res.Message;
          this.showToast();
        }
      })
    },




    // 获取 信用卡支付的的短信验证码   GETYAM
    GetValidateCodeForCreditPay() {
      if (this.Phone.length != 11) {
        this.TellUser = "请输入正确的手机号";
        this.showToast();
        return;
      }

      // 开始计时
      this.haveYZM = true;
      this.WaitTime = this.CloseTime + "秒"
      this.timer();


      var params = new this.URLSearchParam();
      params.append('parentNo', this.g_PayOrder.OrderId);
      params.append('bankCard', this.g_PayOrder.CardNo);
      params.append('phoneNo', this.Phone);
      params.append('orderType', this.g_PayOrder.TypeId)
      this.$http.post(api.GetValidateCodeForCreditPay(this.g_PayOrder.PayFor), params.toParam()).then((res) => {
        console.log(res)

        if (res.Result) {
          this.TellUser = "短信已发送";
          this.showToast();
        }
        else {
          this.TellUser = res.Message;
          this.showToast();

          this.CloseTime = 5;

        }
      })

    },

    timer() {
      if (this.CloseTime > 0) {
        this.CloseTime--;
        this.WaitTime = this.CloseTime + "秒"
        
        setTimeout(this.timer, 1000);
      }
      else if (this.CloseTime == 0) {
        this.haveYZM = false;
        this.CloseTime = 29;
      }
    },
    //  获取验证码  END




    // 付钱了
    PayByUnionPayCreditCardFirst() {    // 信用卡

      if (this.Ispay == true) {
        this.TellUser = '正在支付中。。。';
        this.showToast();
        return
      }

      if (!this.valid()) {
        this.showToast();
        return;
      }

      this.Ispay = true;

      var params = new this.URLSearchParam();
      params.append('accountCardNumber', this.g_PayOrder.CardNo);
      params.append('mobile', this.Phone);
      params.append('smsVerificationCode', this.YZM);
      params.append('orderId', this.g_PayOrder.OrderId);
      params.append('totalPrice', this.g_PayOrder.Money);
      params.append('CVN2', this.CVN2);
      params.append('expiryMonth', this.month);
      params.append('expiryYear', this.year);
      params.append('orderType',this.g_PayOrder.TypeId)
      this.$http.post(api.PayByUnionPayCreditCardFirst(this.g_PayOrder.PayFor), params.toParam()).then((res) => {

        this.Ispay = false;

        if (res.Result) {
          this.TellUser = res.Data;
          this.showToast();

          this.toastTimer1 = setTimeout(() => {
            this.$router.push({
              path: '/order/PayIsOk?result=true&money=' + this.g_PayOrder.Money + '&parentNo=' + this.g_PayOrder.OrderId
              + '&paytype=银联支付&payDate=' + Date.prototype.NowDate()+'&orderType='+ this.g_PayOrder.TypeId
            });
          }, 1800);
        }
        else {
          this.TellUser = res.Message;
          this.showToast();
        }
      })
    },


    // 图片验证码
    getValidateCode() {
      this.TPFJM = api.getValidateCode();
    },

    goback() {
      javascript: history.go(-1);
    },

    // 弹出层
    showToast() {
      this.hideToast();
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
      if (this.TellUser == '未登录') {
        this.$http.post(api.LogOff()).then((res) => { });
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1200)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end
    open(pos) {
      if (pos == 0) {
        this.url = '../../../static/wallet/card_front.png';
      }
      else {
        this.url = '../../../static/wallet/card_oppsite.png';
      }
      this.dialog = true
    },
    close() {
      this.dialog = false
    },

    valid() {
      if (this.CVN2 == '') {
        this.TellUser = '请填写CVN2！';
        return false;
      }
      if (this.month == '') {
        this.TellUser = '请填写月份！';
        return false;
      }
      if (this.year == '') {
        this.TellUser = '请填写年份！';
        return false;
      }
      if (this.Phone == '') {
        this.errTellUserMes = '请填写手机号码！';
        return false;
      }
      if (this.YZM == '') {
        this.TellUser = '请填写验证码！';
        return false;
      }
      else {
        return true;
      }
    }
  },
}    
</script>









<style lang="less" scoped>
@import "../../../assets/theme.less";
.page {
  background-color: white;
  .form {
    margin-top: 10px;
    div {
      position: relative;
      .amount {
        color: black;
      }
      .small {
        color: @textColor;
        font-size: 0.12rem;
      }
      .tip {
        position: absolute;
        right: 4%;
        top: 9px;
      }
    }
  }
  #payMsg {
    div {
      font-size: 0.3rem;
      padding-top: 5px;
      height: 42px;
      span {
        color: @primaryBlack;
      }
      input {
        margin-bottom: 0px;
      }
      .date {
        width: 32px;
        text-align: center;
      }
      #get {
        position: absolute;
        width: 170px;
        top: 0px;
        right: -50px;
        input {
          background-color: @primaryColor;
          color: white;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// NextCredit.vue?a067a2d8